<template>
  <v-card class="pa-8 mt-4">
    <v-card-title class="mb-4 d-flex align-center">
      <v-btn
        class="me-4"
        color="primary"
        size="small"
        icon="fa-solid fa-circle-5"
      />
      <span>
        Configurações
      </span>
    </v-card-title>
    <v-row v-if="settings.length === 0">
      <v-col>
        <span class="text-medium-emphasis">Nenhuma configuração disponível.</span>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        v-for="setting in settings"
        :key="setting.id"
        cols="12"
        sm="6"
        lg="4"
      >
        <v-switch
          v-model="setting.value"
          color="primary"
          :label="setting.description"
          :hint="`Padrão: ${setting.default ? 'Habilitado' : 'Desabilitado'}`"
          persistent-hint
          inset
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts" setup>
import { resolveSettings } from '@/helpers/settings/resolve'
import SettingService from '@/services/SettingService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import Setting from '@/types/Setting'
import { ref, Ref, watch } from 'vue'

interface Props {
  modelValue?: Setting[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [Setting[]]
}>()

const loader = useLoader()
const snackbar = useSnackBar()

const settings: Ref<Setting[]> = ref([])

async function fetchSettings() {
  try {
    loader.increment()

    const response = await new SettingService().index()

    settings.value = resolveSettings(response.data.data, props.modelValue)
  } catch {
    snackbar.show('Erro ao carregar configurações', 'error')
  } finally {
    loader.decrement()
  }
}

watch(settings, (value) => {
  emit('update:modelValue', value)
}, { deep: true })

fetchSettings()
</script>
